import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AdUser } from './api.gen';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import * as MicrosoftGraph from "@microsoft/microsoft-graph-types";



@Injectable({
    providedIn: "root"
})
export class ActiveDirectoryService {
    name: string;
    adUsers: Observable<AdUser[]>;
    constructor(private http: HttpClient) { }
    baseUrl = 'https://graph.microsoft.com/v1.0/users?$top=10&';
    properties = 'id,givenName,displayName,userPrincipalName,surName,firstName,middleName,lastName';

    public getAdUsers(searchText: string): Observable<AdUser[]> {

        const fname = searchText.trim().split(' ')[0];
        const lastname = searchText.trim().split(' ')[1];

        const query = `startswith(displayName,'${searchText}') or
        startswith(userPrincipalName,'${searchText}') or
        (startswith(givenName,'${fname}') and startswith(surname,'${lastname !== null && lastname !== undefined && lastname.length > 1 ? lastname : ' '}'))`;

        this.adUsers = this.http.get(`${this.baseUrl}$select=${this.properties}&$filter=${query}`)
            .pipe(
                map((res: any) => {
                    if (res && res.value) {
                        return res.value.map((u: MicrosoftGraph.User) => new AdUser(u));
                    } else {

                        return [];
                    }
                }),
                shareReplay());

        return this.adUsers;
    }

    public me(): Observable<any> {
        // dummy call to refresh token (if needed) so that AD search will be fast
        return this.http.get(`https://graph.microsoft.com/v1.0/me/displayName`)
            .pipe(
                map((res: any) => {
                    if (res && res.value) {
                        return res.value;
                    }
                    return null;
                })
            );
    }
}
